import { motion } from "framer-motion";
import { Bike } from "lucide-react";

export default function CotizandoOverlay() {
  return (
    <div data-testid="cotizando-overlay" className="fixed inset-0 z-50 bg-white/90 backdrop-blur-sm flex flex-col items-center justify-center px-6">
      <motion.img src="/api/uploads/atm-logo.png" alt="ATM Seguros" className="h-9 w-auto mb-10"
        animate={{ scale: [1, 1.08, 1], opacity: [0.75, 1, 0.75] }}
        transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }} />
      <div className="relative w-64 h-11 overflow-hidden mb-3">
        <div className="absolute bottom-1 left-0 right-0 border-t-2 border-dashed border-slate-300" />
        <motion.div className="absolute bottom-0.5" initial={{ x: -44 }} animate={{ x: 292 }}
          transition={{ repeat: Infinity, duration: 1.7, ease: "linear" }}>
          <Bike className="w-9 h-9 text-emerald-600" />
        </motion.div>
      </div>
      <p className="font-heading font-semibold text-slate-800 text-lg text-center">Estamos cotizando tu moto</p>
      <p className="text-sm text-slate-500 text-center mt-1">Consultando en tiempo real a ATM Seguros, tarda unos segundos...</p>
    </div>
  );
}
